import Columns from './components/ContentList/Columns';
import ContentCard from './components/ContentList/ContentCard';
import Main from './components/ContentList/Main';
import GeneralList from './components/ContentList/GeneralList';
import Pagination from './components/ContentList/Pagination';

window.ContentList = {
    Columns,
    ContentCard,
    Main,
    GeneralList,
    Pagination,
};
